<template>
    <div class="login-page">
        <div class="login-box rounded welcome-container">
            <h2>Welkom!</h2>
            <img src="@/assets/logo_horizontal.png" alt="Logo" width="200" />
            <div v-if="stepOne">
                <p class="instructions">Log in met je email en administratiecode om te beginnen:</p>
                <InputView v-model="adminEmail" type="email" :uppercase="false" class="form-control input-lg" />
                <InputView v-model="adminCode" hint="Code" :uppercase="false" type="password" />
                <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}
                </div>
                <ButtonView text="Start" @click="login" />
            </div>
            <div v-else>
                <p class="instructions">Kies je groep:</p>
                <!-- <p class="instructions-regular">GROEP&hellip;</p> -->
                <ButtonView :text="groupName(0)" @click="continueWithTeam(0)" />
                <ButtonView :text="groupName(1)" @click="continueWithTeam(1)" />
                <ButtonView :text="groupName(2)" @click="continueWithTeam(2)" />
            </div>
        </div>
    </div>
</template>
  
<script>
import ButtonView from '@/components/controlpanel/ButtonView.vue'
import InputView from '@/components/controlpanel/InputView.vue'
import { mapActions } from 'vuex'
import TextUtils from "@/utils/textutils.js"

export default {
    name: 'LoginView',
    data() {
        return {
            adminEmail: '',
            adminCode: '',
            errorMessage: '',
            stepOne: true,
            groupName: TextUtils.teamNameShort,
        };
    },
    methods: {
        ...mapActions(['loginUser', 'setTeam']),
        async login() {
            try {
                const response = await this.loginUser({ email: this.adminEmail, adminCode: this.adminCode });
                console.log(response.data);
                if (response.data.isAdmin && response.data.requiresReset) {
                    this.$router.push('/set-password');
                } else if (response.data.isAdmin) {
                    // This is safe to do, because we will always check the sessionToken server-side. If anyone fakes this response argument, they won't be able to access anything.
                    this.$router.push('/admin');
                } else if(!TextUtils.useTeams) {
                    // No teams configured, go directly to control panel
                    await this.setTeam(0);
                    this.$router.push('/control-panel');
                } else {
                    this.stepOne = false;
                }
            }
            catch (error) {
                console.error(error);
                this.errorMessage = 'Ongeldige administratiecode. Probeer het opnieuw.';
                this.adminCode = '';
            }
        },
        async continueWithTeam(team) {
            await this.setTeam(team);
            this.$router.push('/control-panel');
        }
    },
    components: { ButtonView, InputView }
}
</script>
  
<style>
.login-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: white;
}

h2 {
    font: 700 2.9375rem Roboto;
    color: var(--color-primary);
}

.alert {
    border-radius: 1rem;
}

.instructions {
    margin-top: 0.625rem;
    font: 700 1.78125rem Roboto;
    color: var(--color-primary);
    text-align: center;
}

.instructions-regular {
    margin-top: 0.625rem;
    font: 700 1.78125rem Roboto;
    color: var(--gray-dark);
    text-align: center;
}

.welcome-container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    justify-content: flex-start;
    max-width: 33.25rem;
    padding: 3.25rem 5.5625rem 5.625rem;
    background: #f0f4ff;
    border: 0.09375rem solid var(--color-primary);
    border-radius: 0.8125rem;
    box-shadow: 0rem 0.25rem 0.25rem rgba(0, 0, 0, 0.25);
}
</style>
